<template>
  <Form as="div">
    <div v-cloak id="policy" data-test-component="policy">
      <policy-header class="policy-header" />

      <policy-mode v-if="viewMode === 1 && !!localVueModel" v-model="localVueModel" />

      <confirmation
        v-if="viewMode === 2 && !!localVueModel"
        v-model="localVueModel.ConfirmationPage"
      />

      <policy-modal />
    </div>
  </Form>
</template>

<script>
import { cloneDeep } from 'lodash';
import Utility from '@/common/UtilityFunctions.js';
import Confirmation from './Confirmation.vue';
import PolicyHeader from './Header.vue';
import PolicyModal from './PolicyModal.vue';
import PolicyMode from './PolicyMode.vue';

export default {
  name: 'Policy',
  components: {
    Confirmation,
    PolicyHeader,
    PolicyModal,
    PolicyMode
  },
  data() {
    return {
      localVueModel: null
    };
  },
  computed: {
    viewMode() {
      return this.$store.state.policy.viewMode;
    },
    policyId() {
      return Utility.getQueryVariable('id');
    },
    vueModel() {
      return this.$store.state.policy.vueModel;
    },
    loading() {
      return this.$store.state.policy.loading;
    },
    showModal() {
      return this.$store.state.policy.showModal;
    }
  },
  watch: {
    vueModel(val) {
      this.localVueModel = cloneDeep(val);
    }
  },
  created() {
    this.$store.dispatch('policy/setInitialModel', this.policyId);
  }
};
</script>
